var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIconNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.155788 14.8429C0.205544 14.8927 0.264629 14.9322 0.329666 14.9592C0.394704 14.9861 0.464418 15 0.534822 15C0.605226 15 0.674939 14.9861 0.739977 14.9592C0.805014 14.9322 0.8641 14.8927 0.913855 14.8429L7.49805 8.25928L14.0849 14.8429C14.1855 14.9434 14.3218 14.9999 14.464 14.9999C14.6061 14.9999 14.7425 14.9434 14.843 14.8429C14.9435 14.7424 15 14.606 15 14.4639C15 14.3217 14.9435 14.1854 14.843 14.0849L8.25612 7.50128L14.8403 0.914986C14.9408 0.814469 14.9973 0.678139 14.9973 0.535986C14.9973 0.393834 14.9408 0.257504 14.8403 0.156987C14.7398 0.0564698 14.6035 0 14.4613 0C14.3191 0 14.1828 0.0564698 14.0823 0.156987L7.49805 6.74328L0.911176 0.159665C0.808689 0.0719053 0.676857 0.0260472 0.542025 0.0312547C0.407193 0.0364622 0.279292 0.0923517 0.18388 0.187755C0.0884687 0.283158 0.0325741 0.411048 0.0273662 0.545868C0.0221582 0.680688 0.0680205 0.812508 0.155788 0.914986L6.73999 7.50128L0.155788 14.0876C0.0560068 14.1879 0 14.3237 0 14.4652C0 14.6067 0.0560068 14.7425 0.155788 14.8429Z",
    fill: "#134046"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconNormal);
export default __webpack_public_path__ + "static/media/close_icon_normal.ec9129657dedfb87858ee387ceef836b.svg";
export { ForwardRef as ReactComponent };